import { computed, watch } from "vue";
import { resetFavicon, setFavicon } from "../../core/utils";
import { useGlobalConfigStore } from "../stores/global";

/**
 * favicon管理的composable
 */
export function useFavicon() {
  const globalConfigStore = useGlobalConfigStore();

  // 计算当前应该使用的favicon URL
  const faviconUrl = computed(() => {
    return globalConfigStore.companyConfig.watermark_logo_url || "/vite.svg";
  });

  // 监听favicon变化并自动更新
  watch(
    faviconUrl,
    (newUrl) => {
      if (newUrl && newUrl !== "/vite.svg") {
        setFavicon(newUrl);
      } else {
        resetFavicon();
      }
    },
    { immediate: true }
  );

  // 手动更新favicon
  const updateFavicon = (url?: string) => {
    const targetUrl = url || faviconUrl.value;
    if (targetUrl && targetUrl !== "/vite.svg") {
      setFavicon(targetUrl);
    } else {
      resetFavicon();
    }
  };

  // 重置为默认favicon
  const resetToDefault = () => {
    resetFavicon();
  };

  return {
    faviconUrl,
    updateFavicon,
    resetToDefault,
  };
}
